import { useRef, useState, useEffect } from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { Box } from '@mui/material';
import { DateTime } from 'luxon';

const DatesIntervalInput = (props: GridFilterInputValueProps) => {
  const { item, applyValue, focusElementRef } = props;

  const filterTimeout = useRef<NodeJS.Timeout | undefined>(undefined);
  const [filterState, setFilterState] = useState<
    [DateTime | null, DateTime | null]
  >(item.value ?? [null, null]);

  useEffect(() => {
    return () => {
      clearTimeout(filterTimeout.current);
    };
  }, []);

  useEffect(() => {
    const itemValue = item.value ?? [undefined, undefined];
    setFilterState(itemValue);
  }, [item.value]);

  const updateFilterValue = (
    fromDate: DateTime | null,
    toDate: DateTime | null,
  ) => {
    clearTimeout(filterTimeout.current);
    setFilterState([fromDate, toDate]);

    filterTimeout.current = setTimeout(() => {
      applyValue({ ...item, value: [fromDate, toDate] });
    }, 500);
  };

  const handleFromChange: DateTimePickerProps<DateTime>['onChange'] = (
    value,
    _context,
  ) => {
    updateFilterValue(value, filterState[1]);
  };
  const handleToChange: DateTimePickerProps<DateTime>['onChange'] = (
    value,
    _context,
  ) => {
    updateFilterValue(filterState[0], value);
  };
  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'end',
        gap: 1,
        pl: '20px',
        flexWrap: 'wrap',
      }}
    >
      <DateTimePicker
        inputRef={focusElementRef}
        value={filterState[0]}
        onChange={handleFromChange}
        label="From"
        slotProps={{
          textField: {
            variant: 'standard',
          },
        }}
      />
      <DateTimePicker
        label="To"
        value={filterState[1]}
        onChange={handleToChange}
        slotProps={{
          textField: {
            variant: 'standard',
          },
        }}
      />
    </Box>
  );
};

export default DatesIntervalInput;
